import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    name: 'home',
    component: DefaultLayout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/Home.vue'),
      },
      {
        path: '/site/index',
        redirect: '/home',
      },
      {
        path: '/nosotros/index',
        name: 'Nosotros',
        component: () => import('@/views/nosotros/nosotros.vue'),
      },
      {
        path: '/utilitarios',
        name: 'Utilitarios',
        component: () => import('@/views/nosotros/nosotros.vue'),
      },
      {
        path: '/noticias/index',
        name: 'Noticias',
        component: () => import('@/views/noticias/noticias.vue'),
      },
      {
        path: '/contacto/index',
        name: 'Contacto',
        component: () => import('@/views/contacto/contacto.vue'),
      },
      {
        path: '/utilitarios',
        name: 'Utilitarios',
        component: () => import('@/views/utilitarios/utilitarios.vue'),
      },
      {
        path: '/stock',
        name: 'Stock',
        component: () => import('@/views/stock/stock.vue'),
      },
      {
        path: '/stockfull',
        name: 'StockFull',
        component: () => import('@/views/stock/stockfull.vue'),
      },
      {
        path: '/papel',
        name: 'Papel',
        component: () => import('@/views/productos/papel.vue'),
      },
      {
        path: '/hkaprint',
        name: 'HKAPrint',
        component: () => import('@/views/productos/hkaprint.vue'),
      },
      {
        path: '/productos',
        name: 'Productos',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/productos/impresoras',
        children: [
          {
            path: 'impresoras',
            name: 'Impresoras',
            component: () => import('@/views/productos/impresoras.vue'),
          },
          {
            path: 'impresoras/:tipo',
            name: 'Impresora',
            props: true,
            component: () => import('@/views/productos/impresora.vue'),
          },
          {
            path: 'cajas',
            name: 'Cajas',
            component: () => import('@/views/productos/cajas.vue'),
          },
          {
            path: 'cajas/:tipo',
            name: 'Caja',
            props: true,
            component: () => import('@/views/productos/caja.vue'),
          },
          {
            path: 'captura',
            name: 'Capturas',
            component: () => import('@/views/productos/dispositivos.vue'),
          },
          {
            path: 'captura/:tipo',
            name: 'Captura',
            props: true,
            component: () => import('@/views/productos/dispositivo.vue'),
          },
          {
            path: 'balanzas',
            name: 'Balanzas',
            component: () => import('@/views/productos/balanzas.vue'),
          },
          {
            path: 'balanzas/:tipo',
            name: 'Balanza',
            props: true,
            component: () => import('@/views/productos/balanza.vue'),
          },
          {
            path: 'perifericos',
            name: 'Perifericos',
            component: () => import('@/views/productos/perifericos.vue'),
          },
          {
            path: 'puntosdeventafiscal',
            name: 'Puntos',
            component: () =>
              import('@/views/productos/puntosdeventafiscal.vue'),
          },
          {
            path: 'puntosdeventafiscal/:tipo',
            name: 'Punto',
            props: true,
            component: () => import('@/views/productos/puntodeventafiscal.vue'),
          },
        ],
      },
      {
        path: '/privacidad/index',
        name: 'Privacidad',
        component: () => import('@/views/privacidad/privacidad.vue'),
      },
      {
        path: '/sr',
        name: 'Servicio',
        component: () => import('@/views/servicio/index.vue'),
      },
      {
        path: '/comunicado',
        name: 'Comunicado',
        component: () => import('@/views/comunicado/comunicado.vue'),
      },
      {
        path: '/certificados',
        name: 'certificados',
        component: () => import('@/views/certificado/index.vue'),
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '501',
        name: 'Page501',
        component: () => import('@/views/pages/Page500'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/home',
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/home',
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
